module.exports = __webpack_public_path__ + "img/vytyazhka.ea5ef4ad.svg";